module.exports = __webpack_public_path__ + "landing_static/img/header-xs-t.a168af91.png";